import { ProfileFormField } from '../components/ProfileFormField';
import EntityFormProvider from '../EntityFormProvider';

export default function Vulnerabilities() {
  return (
    <EntityFormProvider title="Vulnerabilities">
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="is_vulnerable_client"
        label="Classified as a vulnerable client"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="has_caring_responsibilities"
        label="Caring responsibilities"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="caring_responsibilities_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="has_difficulty_with_literacy_numeracy_or_computer_skills"
        label="Difficulty with literacy, numeracy or computer skills"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="literacy_numeracy_computer_skills_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="has_language_barrier"
        label="Language barrier"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="language_barrier_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="has_recent_life_events"
        label="Any recent life events"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="recent_life_events_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="has_worries_about_money"
        label="Any worries about money"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="worries_about_money_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="has_other_potential_areas_of_vulnerability"
        label="Any other potential areas of vulnerability"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="potential_areas_of_vulnerability_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Vulnerability"
        fieldName="vulnerable_client_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="PersonalDetails"
        fieldName="is_bankrupt"
        label="Subject to bankruptcy/IVA"
      />
    </EntityFormProvider>
  );
}
